export default __webpack_public_path__ + "static/media/DOLLER_COIN.7924f1c7.png";